export const ACCORDION_ERRORS = {
  context: 'Accordion component was not found in the tree',
  itemContext: 'Accordion.Item component was not found in the tree',
  value: 'Accordion.Item component was rendered with invalid value or without value',
};
